import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';
import PageLoading from '@/account/pages/PageLoading';

class SaveCartPopUpLoader {
  static load({ t }) {
    const SaveCartLazy = Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "popup-save-cart" */ '@/components/popup/SaveCart'
        ),
      loading: PageLoading,
    });
    ReactDOM.render(
      <SaveCartLazy t={t} />,
      document.getElementById('js-dln-popup__wrapper'),
    );
  }
}

export default SaveCartPopUpLoader;
